import ElementUI from 'element-ui/lib/locale/lang/zh-TW';
const env = {
  'env.title': 'Sonice Notify',
};
const label = {
  'label.account': '帳號',
  'label.cancel': '取消',
  'label.delete': '刪除',
  'label.logout': '登出',
  'label.ok': '確定',
  'label.register': '註冊',
  'label.save': '儲存',
  'label.update': '更新',
  'label.otp': '驗證碼',
};
const please = {
  'please.enter': '請輸入{label}',
  'please.select': '請選擇{label}',
};
const slot = {
  'slot.create': '新增{label}',
  'slot.delete': '刪除{label}',
  'slot.detail': '{label}明細',
  'slot.edit': '編輯{label}',
  'slot.error': '{label}錯誤',
  'slot.failed': '{label}失敗',
  'slot.format.positive': '{label}需為正數',
  'slot.formatError': '{label}格式不正確',
  'slot.input.require': '{label}欄位不能為空',
  'slot.optional': '{label}(選填)',
  'slot.repeat': '{label}不能重複',
  'slot.success': '{label}成功',
};
const warn = {
  'warn.systemError': '系統錯誤',
  'warn.confirm': '提示',
  'warn.confirmDelete': '確定要刪除{label}嗎',
  'warn.endMustBeLaterThanStart': '{label}開始日期不能大於結束日期',
  'warn.endMustBeLaterThanToday': '{label}日期不能大於今日',
  'warm.failSize': '文件大小超出限制(最大{label}MB)',
  'warn.incorrectUsernameOrPassword': '帳號或密碼錯誤',
  'warn.loginFailed': '登入失敗',
  'warn.pwdNotSame': '密碼與確認密碼不一致'.trim(), //for scan
  'warn.pwdRule': '密碼長度至少8碼'.trim(), //for scan
  'warn.userIsDisabled': '帳號遭停權',
  'warn.notifyTokenIsEmpty': '未獲取手機推播Token\n請關閉 APP 重新開啟後再試',
  'warn.tokenExpired': 'TOKEN 驗證已過期，請重新登入',
};
//
const auth = {
  'auth.disabled': '帳號遭停權',
  'auth.loginFailed': '登入失敗',
  'auth.wrongAccountOrPassword': '帳號或密碼錯誤',
};
const common = {
  "header.title.channel": "頻道列表",
  "header.title.notification": "通知紀錄",
  "header.title.setting": "個人設定",

  "pageTab.channel": "首頁",
  "pageTab.notification": "通知",
  "pageTab.setting": "個人設定",
};
const COMMON = {

}
const settingPage = {
  'settingPage.confirm.deleteAccount': '刪除帳號後將無法恢復，\n請確認是否繼續。',
  'settingPage.confirm.deleteAccount2': '我了解此操作\n將永久刪除我的帳號及設定',
  'settingPage.warn.deleteAccount': '帳號資料及設定將會被刪除\n再次確認是否要刪除？',
}

export default {
  ...ElementUI,
  //
  ...env,
  ...label,
  ...please,
  ...slot,
  ...warn,
  //
  ...auth,
  ...common,
  ...COMMON,

  //
  ...settingPage,
};
